import React, { useEffect, useState } from "react";
import "./App.css";
import Faq from "./components/Faq";
import Reviews from "./components/Reviews";
// import "primereact/resources/themes/lara-light-cyan/theme.css";

// import "primereact/resources/themes/saga-blue/theme.css";
// import "primereact/resources/primereact.min.css";
// import "primeicons/primeicons.css";
// import "primeflex/primeflex.css";

function App() {
  const [bg, setbg] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);
  const controlNavbar = () => {
    if (window.scrollY > 50) {
      setbg(true);
    } else {
      setbg(false);
    }
    setLastScrollY(window.scrollY);
  };
  useEffect(() => {
    window.addEventListener("scroll", controlNavbar);
    return () => {
      window.removeEventListener("scroll", controlNavbar);
    };
  }, [lastScrollY]);

  return (
    <div className="App min-h-screen relative flex flex-col items-center bg-white">
      <nav
        className={`nav ${
          bg && "bg-loana-blue/40 backdrop-blur-xl overflow-hidden"
        }`}
      >
        <div className="flex items-center">
          <div
            style={{ fontFamily: "Aeonik Regular" }}
            className="flex items-center justify-center"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              className="size-9 -rotate-[130deg] fill-loana-black"
            >
              <path
                fill-rule="evenodd"
                d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-.53 14.03a.75.75 0 0 0 1.06 0l3-3a.75.75 0 1 0-1.06-1.06l-1.72 1.72V8.25a.75.75 0 0 0-1.5 0v5.69l-1.72-1.72a.75.75 0 0 0-1.06 1.06l3 3Z"
                clip-rule="evenodd"
              />
            </svg>
            <p className="text-white text-lg font-medium ml-1">Loana</p>
          </div>
        </div>
        <ul className="md:flex hidden items-center gap-8 text-white *:font-medium *:tracking-wider text-sm">
          <li className="cursor-pointer hover:text-loana-blue">Products</li>
          <li className="cursor-pointer hover:text-loana-blue">Company</li>
          <li className="cursor-pointer hover:text-loana-blue">Contact</li>
        </ul>
        <div className="md:flex hidden items-center gap-3 *:px-4 *:text-[0.9rem]">
          <p className="cursor-pointer text-sm font-medium tracking-wide text-white hover:text-loana-blue">
            Login
          </p>
          <button className="bg-white capitalize text-sm font-semibold tracking-wider text-loana-blue outline-none outline-0 ring-1 ring-inset hover:bg-loana-blue hover:text-white ring-loana-blue/20 px-4 py-2 rounded-full">
            Get Started
          </button>
        </div>
        <div className="bg-white/50 border border-loana-black/10 shadow cursor-pointer hover:bg-loana-black group md:hidden block p-1 rounded-full">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            className="size-6 stroke-loana-black group-hover:stroke-white"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
            />
          </svg>
        </div>
      </nav>

      <div className="bg-loana-homex h-[120vh] absolute top-0 left-0 w-full bg-cover bg-no-repeat bg-center opacity-50x"></div>

      <div className="h-[120vh] bg-[#4D83FF]/90 absolute top-0 left-0 w-full z-20 bg-center opacity-50"></div>

      <section className="mt-20 sm:mt-32 px-2 pt-2 relative overflow-hidden w-full sm:h-[90vh] flex flex-col justify-center items-center">
        <p className="relative z-30 leading-[3rem] text-3xl sm:text-5xl mt-6 text-loana-black px-3x max-w-xl !font-extrabold tracking-wide sm:leading-[4rem] text-center">
          Everything you need to unlock financial freedom
        </p>
        <p className="mt-4 relative z-30 w-10/12 sm:w-full sm:text-xl max-w-md sm:max-w-xl text-center text-loana-black/80 font-medium">
          At Loana we help users attain their financial goals by issuing instant
          loans and high interest savings.
        </p>
        <button className="bg-white capitalize mt-8 relative z-30 text-sm font-semibold tracking-wider text-loana-blue outline-none outline-0 ring-1 ring-inset hover:bg-loana-blue hover:text-white ring-loana-blue/20 px-5 py-3 rounded-full">
          Get Started - It's free🥳
        </button>
        <div className="bg-loana-black relative z-30 max-h-[300px] md:max-h-[600px] flex-1 p-6 mt-8 sm:mt-16 w-11/12 sm:w-10/12 rounded-t-xl sm:rounded-t-3xl overflow-hidden">
          <div className="flow-root bg-loana-light rounded-t-xl sm:rounded-t-3xl bg-dash h-[500px] md:h-[600px] w-full bg-cover">
            {/* <div className="bg-gray-900/5 ring-1 ring-gray-900/10 -m-2 rounded-xl p-2 ring-inset lg:-m-4 lg:rounded-2xl lg:p-4">
              <img
                // src="https://tailwindui.com/img/component-images/project-app-screenshot.png"
                src=""
                alt="App screenshot"
                width="2432"
                height="1442"
                className="ring-1 ring-gray-900/10 rounded-md shadow-2xl"
              />
            </div> */}
          </div>
        </div>
      </section>

      <section className="bg-white min-h-full w-full grid place-items-center relative z-30 pt-24 sm:pt-24">
        <div className="md:w-9/12 w-10/12 mt-32 sm:mt-24 flex flex-col h-full">
          <p className="text-4xl font-bold text-loana-black">
            Rewrite your future
          </p>
          <p className="text-[#233546] font-medium mt-3">
            Access quick loans when you need them and watch your <br /> savings
            grow with our high interest rates{" "}
          </p>
          <div className="flex-1 grid lg:grid-cols-2 lg:gap-12 mt-9 *:p-8 *:md:p-16 *:rounded-[20px]">
            <div className="bg-loana-black h-[40vh] lg:h-[65vh] *:text-white relative overflow-hidden">
              <p className="text-[30px] tracking-wide leading-[2.5rem] relative z-10 font-extrabold">
                High Savings <br /> Interest Rates.
              </p>
              <div className="bg-white p-5 grid grid-cols-5 gap-2 h-max rounded-3xl absolute bottom-[10%] sm:bottom-[20%] md:top-[40%] -right-20 sm:-right-10 shadow-xl shadow-[#264197]/20 w-max z-10">
                <div className="bg-[#E7EAFF] col-span-1 h-14 w-14 grid place-items-center rounded-full ring-1 ring-inset ring-[#4761EB]/20">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    className="size-6 stroke-[#4761EB]"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M14.857 17.082a23.848 23.848 0 0 0 5.454-1.31A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.967 8.967 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0"
                    />
                  </svg>
                </div>
                <div className="col-span-4">
                  <p className="!text-[#8592AD] uppercase text-xs tracking-widest">
                    Notifications
                  </p>
                  <p className="!text-loana-black font-semibold text-sm mt-2">
                    Your savings account has been credited <br /> with N3000
                    interest.
                  </p>
                </div>
              </div>
              <img
                src={require("./assets/images/cardimg.png")}
                alt=""
                className="absolute -left-10 -bottom-20 opacity-50 md:opacity-70"
              />
            </div>
            <div className="bg-[#EAF1FB] h-[40vh] lg:h-[65vh] bg-card-bg flex flex-col justify-between w-full bg-cover bg-center relative overflow-hidden">
              <p className="text-[30px] tracking-wide leading-[2.5rem] font-extrabold">
                Apply to Loans <br />
                Quickly and Easily.
              </p>
              <div className="bg-white hidden lg:block absolute p-3 md:p-7 w-fit rounded-3xl min-w-[400px] bottom-[10%] md:bottom-[32%] border-2 z-20 ring-inset border-[#4761EB] shadow-xl shadow-[#264197]/20 md:-rotate-3">
                <p className="text-sm font-semibold text-loana-black">
                  Business
                </p>
                <div className="bg-[#F1F1F1] w-full p-2 mt-3 relative overflow-hidden rounded-full">
                  <div className="bg-[#F5B948] w-10/12 absolute p-2 top-0 left-0 rounded-full"></div>
                </div>
                <div className="flex justify-between mt-3">
                  <div className="text-left">
                    <p className="text-[#8592AD] text-xs capitalize font-medium">
                      Repayable amount
                    </p>
                    <p className="text-loana-black font-semibold">
                      <small className="text-[11px]">N</small>200,000.
                      <small className="text-[11px]">00</small>
                    </p>
                  </div>
                  <div className="text-right">
                    <p className="text-[#8592AD] text-xs capitalize font-medium">
                      Loan amount
                    </p>
                    <p className="text-loana-black font-semibold">
                      <small className="text-[11px]">N</small>190,000.
                      <small className="text-[11px]">00</small>
                    </p>
                  </div>
                </div>
              </div>
              <div className="bg-white p-7 bottom-[15%] -rotate-6 sm:rotate-0 md:bottom-[12%] absolute w-max flex items-center gap-5 rounded-3xl shadow-xl shadow-[#264197]/20 z-10">
                <div className="bg-[#59C647] col-span-1 h-10 w-10 grid place-items-center rounded-full">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    className="size-6 stroke-white"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="m4.5 12.75 6 6 9-13.5"
                    />
                  </svg>
                </div>
                <div className="">
                  <p className="!text-loana-black font-semibold text-sm">
                    Your loan application for your business <br /> has been
                    approved
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-loana-black min-h-[60vh] w-full grid place-items-center text-white relative overflow-hidden mt-32 z-30 py-24">
        <div className="relative z-10 w-10/12 md:w-9/12">
          <p className="text-4xl font-bold">
            Stay in control of your money <br /> with a Loana account.
          </p>
          <div className="mt-20 overflow-hidden grid sm:grid-cols-2 gap-10">
            <div className="flex sm:flex-row flex-col gap-4 border-l sm:border-transparent border-white/50 sm:pl-0 pl-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                className="size-6"
              >
                <path
                  fill-rule="evenodd"
                  d="M14.615 1.595a.75.75 0 0 1 .359.852L12.982 9.75h7.268a.75.75 0 0 1 .548 1.262l-10.5 11.25a.75.75 0 0 1-1.272-.71l1.992-7.302H3.75a.75.75 0 0 1-.548-1.262l10.5-11.25a.75.75 0 0 1 .913-.143Z"
                  clip-rule="evenodd"
                />
              </svg>
              <div>
                <p className="text- font-semibold tracking-wide">
                  Instant Approvals
                </p>
                <p className="text-sm mt-1 font-medium text-sub-text sm:w-[300px]">
                  No more waiting get instant loan approvals within minutes.
                </p>
              </div>
            </div>
            <div className="flex sm:flex-row flex-col gap-4 border-l sm:border-transparent border-white/50 sm:pl-0 pl-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                className="size-6"
              >
                <path d="M12.75 12.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM7.5 15.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM8.25 17.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM9.75 15.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM10.5 17.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM12 15.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM12.75 17.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM14.25 15.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM15 17.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM16.5 15.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM15 12.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM16.5 13.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z" />
                <path
                  fill-rule="evenodd"
                  d="M6.75 2.25A.75.75 0 0 1 7.5 3v1.5h9V3A.75.75 0 0 1 18 3v1.5h.75a3 3 0 0 1 3 3v11.25a3 3 0 0 1-3 3H5.25a3 3 0 0 1-3-3V7.5a3 3 0 0 1 3-3H6V3a.75.75 0 0 1 .75-.75Zm13.5 9a1.5 1.5 0 0 0-1.5-1.5H5.25a1.5 1.5 0 0 0-1.5 1.5v7.5a1.5 1.5 0 0 0 1.5 1.5h13.5a1.5 1.5 0 0 0 1.5-1.5v-7.5Z"
                  clip-rule="evenodd"
                />
              </svg>
              <div>
                <p className="font-semibold tracking-wide">
                  Repayment Extension
                </p>
                <p className="text-sm mt-1 font-medium text-sub-text sm:w-[300px]">
                  Apply to extend your loan repayment date for your convenience.
                </p>
              </div>
            </div>
            <div className="flex sm:flex-row flex-col gap-4 border-l sm:border-transparent border-white/50 sm:pl-0 pl-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                className="size-6"
              >
                <path
                  fill-rule="evenodd"
                  d="M2.25 2.25a.75.75 0 0 0 0 1.5H3v10.5a3 3 0 0 0 3 3h1.21l-1.172 3.513a.75.75 0 0 0 1.424.474l.329-.987h8.418l.33.987a.75.75 0 0 0 1.422-.474l-1.17-3.513H18a3 3 0 0 0 3-3V3.75h.75a.75.75 0 0 0 0-1.5H2.25Zm6.54 15h6.42l.5 1.5H8.29l.5-1.5Zm8.085-8.995a.75.75 0 1 0-.75-1.299 12.81 12.81 0 0 0-3.558 3.05L11.03 8.47a.75.75 0 0 0-1.06 0l-3 3a.75.75 0 1 0 1.06 1.06l2.47-2.47 1.617 1.618a.75.75 0 0 0 1.146-.102 11.312 11.312 0 0 1 3.612-3.321Z"
                  clip-rule="evenodd"
                />
              </svg>
              <div>
                <p className="font-semibold tracking-wide">
                  Competitive Interest Rates
                </p>
                <p className="text-sm mt-1 font-medium text-sub-text sm:w-[300px]">
                  We offer rates that rival the best in the market, to meet your
                  needs.
                </p>
              </div>
            </div>
            <div className="flex sm:flex-row flex-col gap-4 border-l sm:border-transparent border-white/50 sm:pl-0 pl-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                className="size-6"
              >
                <path d="M3.53 2.47a.75.75 0 0 0-1.06 1.06l18 18a.75.75 0 1 0 1.06-1.06l-18-18ZM22.676 12.553a11.249 11.249 0 0 1-2.631 4.31l-3.099-3.099a5.25 5.25 0 0 0-6.71-6.71L7.759 4.577a11.217 11.217 0 0 1 4.242-.827c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113Z" />
                <path d="M15.75 12c0 .18-.013.357-.037.53l-4.244-4.243A3.75 3.75 0 0 1 15.75 12ZM12.53 15.713l-4.243-4.244a3.75 3.75 0 0 0 4.244 4.243Z" />
                <path d="M6.75 12c0-.619.107-1.213.304-1.764l-3.1-3.1a11.25 11.25 0 0 0-2.63 4.31c-.12.362-.12.752 0 1.114 1.489 4.467 5.704 7.69 10.675 7.69 1.5 0 2.933-.294 4.242-.827l-2.477-2.477A5.25 5.25 0 0 1 6.75 12Z" />
              </svg>

              <div>
                <p className="font-semibold tracking-wide">No Hidden Fees</p>
                <p className="text-sm mt-1 font-medium text-sub-text sm:w-[300px]">
                  We pride ourselves with our transparency, giving you a clear
                  breakdown of your loan.
                </p>
              </div>
            </div>
          </div>
        </div>
        <img
          src={require("./assets/images/cardbgagn.png")}
          alt=""
          className="absolute -right-14 pl-24"
        />
      </section>

      <section className="bg-white min-h-full w-full grid place-items-center relative z-30 pt-24 sm:pt-20">
        <div className="md:w-9/12 w-10/12 mt-24 flex flex-col h-full">
          <p className="text-4xl font-bold text-loana-black">
            Got Questions? <br /> We've got answers!
          </p>
          <Faq />
        </div>
      </section>

      <section className="bg-white min-h-max w-full flex flex-col items-center relative z-30 mb-12 sm:mb-24 pt-24 sm:pt-20 overflow-hidden">
        <div className="md:w-9/12 w-10/12 mt-12 flex flex-col h-full">
          <p className="text-4xl font-bold text-loana-black">
            Hear from users like <br />
            you that have trusted us
          </p>
        </div>
        <Reviews />
        {/* <div className="bg-gradient-to-r from-white to-transparent h-full p-3 w-[150px] absolute top-0 left-0 z-10"></div> */}
        {/* <div className="bg-gradient-to-l from-white to-transparent h-full p-3 w-[150px] absolute top-0 right-0 z-10"></div> */}
        {/* <div className="bg-white p-2 relative w-full animate-infinite-scroll mt-12 sm:[mask-image:_linear-gradient(to_right,transparent_0,_black_300px,_black_calc(100%-200px),transparent_100%)]">
          <div className="flex">
            <div className="flex gap-4 relative right-[20%]">
              <Review />
              <Review dark />
              <Review />
              <Review dark />
              <Review />
              <Review dark />
              <Review />
              <Review dark />
            </div>
          </div>
          <div className="hidden sm:flex mt-4">
            <div className="flex gap-4 relative right-[10%]">
              <Review dark />
              <Review />
              <Review dark />
              <Review />
              <Review dark />
              <Review />
              <Review dark />
              <Review />
            </div>
          </div>
        </div> */}
      </section>

      <footer className="mt-24 grid place-items-center bg- w-full px-3 sm:px-7">
        <div className="w-11/12 sm:w-10/12 grid sm:grid-cols-5 gap-6 sm:gap-2 mb-10">
          <div className="col-span-2">
            <div className="flex items-center">
              <p
                style={{ fontFamily: "Aeonik Regular" }}
                className="text-loana-black text-lg inline-flex items-center gap-1 font-extrabold"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  className="size-6 -rotate-[130deg] fill-loana-black"
                >
                  <path
                    fill-rule="evenodd"
                    d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-.53 14.03a.75.75 0 0 0 1.06 0l3-3a.75.75 0 1 0-1.06-1.06l-1.72 1.72V8.25a.75.75 0 0 0-1.5 0v5.69l-1.72-1.72a.75.75 0 0 0-1.06 1.06l3 3Z"
                    clip-rule="evenodd"
                  />
                </svg>
                Loana
              </p>
            </div>
            <p className="text-sm mt-2">
              Attain your financial goals with Loana.
            </p>
            <div className="flex gap-2 mt-2">
              <div className="border border-loana-black hover:bg-loana-black group grid place-items-center rounded-full cursor-pointer">
                <i className="fa-brands fa-instagram size-6 grid place-items-center text-loana-black group-hover:text-white"></i>
              </div>
              <div className="border border-loana-black hover:bg-loana-black group grid place-items-center rounded-full cursor-pointer">
                <i className="fa-brands fa-facebook-f size-6 grid place-items-center text-loana-black group-hover:text-white"></i>
              </div>
              <div className="border border-loana-black hover:bg-loana-black group grid place-items-center rounded-full cursor-pointer">
                <i className="fa-brands fa-x-twitter size-6 grid place-items-center text-loana-black group-hover:text-white"></i>
              </div>
            </div>
          </div>
          <div className="flex flex-col gap-2">
            <p className="font-semibold text-sm mb-1.5">Company</p>
            <a
              href="/"
              className="text-xs font-medium text-sub-text hover:text-loana-black"
            >
              About Us
            </a>
            <a
              href="/"
              className="text-xs font-medium text-sub-text hover:text-loana-black"
            >
              Contact
            </a>
          </div>
          <div className="flex flex-col gap-2">
            <p className="font-semibold text-sm mb-1.5">Products</p>
            <a
              href="/"
              className="text-xs font-medium text-sub-text hover:text-loana-black"
            >
              Savings
            </a>
            <a
              href="/"
              className="text-xs font-medium text-sub-text hover:text-loana-black"
            >
              Loans
            </a>
          </div>
          <div className="flex flex-col gap-2">
            <p className="font-semibold text-sm mb-1.5">Support</p>
            <a
              href="/"
              className="text-xs font-medium text-sub-text hover:text-loana-black"
            >
              Help Center
            </a>
            <a
              href="/"
              className="text-xs font-medium text-sub-text hover:text-loana-black"
            >
              FAQs
            </a>
          </div>
        </div>
        <div className="pt-3 pb-6 border-t  w-full text-center text-xs text-sub-text">
          <p className="mb-2">
            Designed by{" "}
            <a
              href="https://www.instagram.com/adathe.designer/"
              className="hover:bg-loana-blue hover:text-white hover:p-1"
            >
              Adaeze
            </a>{" "}
            built by{" "}
            <a
              href="https://ikenna.vercel.app/"
              className="hover:bg-loana-stroke hover:text-loana-black hover:p-1"
            >
              Ikenna
            </a>{" "}
          </p>
          <p>Copyright &copy; 2024 Nameofc. All Rights Reserved.</p>
        </div>
      </footer>
    </div>
  );
}

export default App;
